import React from 'react';
import { componentService } from 'js/services/component.service';

export const TransactionHistory = React.lazy(() => import(/* webpackChunkName: "transaction-history" */ './TransactionHistory'));

componentService.registerPageComponents({ 'transaction-history': TransactionHistory });
